import { api } from '@/lib/api-client'
import type { AuthResponse, LoginRequest } from '@/types/api'

/** Exchanges an email-or-phone plus password for a JWT. Sent without a token. */
export function login(payload: LoginRequest): Promise<AuthResponse> {
  return api.post<AuthResponse>('/api/auth/login', payload, { anonymous: true })
}
